import React from 'react';

import StudentInvitationAcceptedContainer from './StudentInvitationAcceptedContainer';

const StudentInvitationAccepted = () => <StudentInvitationAcceptedContainer />;

export default StudentInvitationAccepted;
